import _styled from "@emotion/styled-base";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import isPropValid from '@emotion/is-prop-valid';
import createEmotion from 'create-emotion';
export { withTheme, useTheme } from 'emotion-theming';
export { ThemeContext } from '@emotion/core';
var emotion = createEmotion({
  container: document.getElementById('emotionModules') || document.head,
  // @ts-expect-error - Internal Use Only
  nonce: window.CSP_NONCE
});
var flush = emotion.flush,
    hydrate = emotion.hydrate,
    cx = emotion.cx,
    merge = emotion.merge,
    getRegisteredStyles = emotion.getRegisteredStyles,
    injectGlobal = emotion.injectGlobal,
    keyframes = emotion.keyframes,
    css = emotion.css,
    sheet = emotion.sheet,
    cache = emotion.cache;
export { flush, hydrate, cx, merge, getRegisteredStyles, injectGlobal, keyframes, css, sheet, cache };
export default (function (Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isTag = typeof Component === 'string';

  var _options$forwardColor = options.forwardColorProp,
      forwardColorProp = _options$forwardColor === void 0 ? false : _options$forwardColor,
      _options$ignoredForwa = options.ignoredForwardProps,
      ignoredForwardProps = _options$ignoredForwa === void 0 ? [] : _options$ignoredForwa,
      restOptions = _objectWithoutProperties(options, ["forwardColorProp", "ignoredForwardProps"]);

  return /*#__PURE__*/_styled(Component, _objectSpread(_objectSpread({}, restOptions), {}, {
    shouldForwardProp: function shouldForwardProp(prop) {
      var shouldForwardProp = restOptions.shouldForwardProp;
      var forwardProp = shouldForwardProp ? shouldForwardProp(prop) : true;
      var shouldPropBeForwarded = !ignoredForwardProps.includes(prop) && forwardProp; // If the component is a non intrinsic element, then don't ignore the color prop

      if (!isTag || forwardColorProp) {
        return shouldPropBeForwarded;
      }

      return isPropValid(prop) && shouldPropBeForwarded && prop !== 'color';
    },
    target: "e1ogoif70"
  }));
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/styles/emotion.js
// module id = 124
// module chunks = 0